<template>
    <NuxtLayout :class="css.container" name="main-small">
        <div :class="css.header" ref="header">
            <!-- * 突变信息窗口 -->
            <module-mutation-info ref="modal" @next="methods.prediction" />
            <!-- * 导航 -->
            <module-navigations :class="css.navigations" :option="modes" :data="data" :id="id" @update="methods.mode" />
            <div class="container">
                <!-- * 控制器 -->
                <div :class="css.controls">
                    <div :class="css.module">
                        <ui-select v-model="id" ref="select" :width="320" :z-index="67" :candidates="data.mrnas" @change="methods.change" />
                    </div>
                    <div :class="css.module">
                        <ui-form-item :class="css.checker" ref="checker">
                            <default-search v-model="keyword" :width="360" :placeholder="$t('PleaseEnterMutation')" @search="methods.search" />
                        </ui-form-item>
                        <ui-button @click="methods.search" style="margin: 0 8px">{{ $t("Search") }}</ui-button>
                        <helper-modal :z-index="666">
                            <div>
                                <div style="font-weight: 700">{{ $t("ExampleData", 2) }}:</div>
                                <ul v-if="mode == 'codon'">
                                    <li>1、p.A3F(GCT>TTT)</li>
                                    <li>2、p.R75X</li>
                                </ul>
                                <ul v-else>
                                    <li>1、g.12G>C</li>
                                    <li>2、c.123G>A</li>
                                    <li>3、c.123_124TG>C</li>
                                    <li>4、c.169+2T>C</li>
                                    <li>5、c.45_46insGC</li>
                                    <li>6、c.36_38del</li>
                                    <li>7、c.45_48delinsTT</li>
                                    <li>8、c.-1G>T</li>
                                    <li>9、c.*16G>T</li>
                                    <li>10、c.23+4_23+5GG>CT</li>
                                    <li>11、p.A3F(GCT>TTT)</li>
                                    <li>12、p.R75X</li>
                                    <li>13、IVS2+1</li>
                                </ul>
                            </div>
                        </helper-modal>

                        <ui-button :class="css_button.green" style="margin-left: 16px" @click="methods.next">
                            {{ $t("GeneSequenceInfo", { name: data.name }) }}
                        </ui-button>
                    </div>
                </div>

                <!-- * 分割线 -->
                <div :class="css.division"></div>

                <!-- * 功能选项 -->
                <div :class="css.controls">
                    <div :class="css.module">
                        <ui-checkbox :class="css.extra" v-model="all" value="all" @change="methods.checkbox(true)">{{ $t("All") }}</ui-checkbox>
                        <!-- * 筛选项 -->
                        <ui-checkbox-group v-model="selects" style="margin-left: var(--size-40-40-24)" @change="methods.checkbox(false)">
                            <template v-for="value in selector" :key="value.value">
                                <ui-checkbox :style="`--checkbox-color:${colors[value.value]}`" :value="value.value" :disabled="!value.number">
                                    {{ value.name }}: {{ value.number }}
                                </ui-checkbox>
                            </template>
                        </ui-checkbox-group>
                        <div :class="css.target" v-show="range.length">
                            <span>{{ $t("MutationInterest") }}</span>
                        </div>
                    </div>

                    <div :class="css.module">
                        <default-search
                            v-model="exon"
                            :width="320"
                            :option="exons"
                            :placeholder="$t('SearchExonPlaceholder')"
                            @search="methods.exon" />
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <!-- * 序列组件 -->
            <module-sequence ref="sequence" @info="methods.info" @next="methods.prediction" :specie="data.specie" />
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiSelect, UiButton, UiCheckbox, UiFormItem, UiCheckboxGroup } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
import { HelperModal } from "@/components/windows";
//* 私有组件
import ModuleSequence from "@/views/tool/components/sequence/index.vue";
import ModuleNavigations from "@/views/tool/components/navigations/index.vue";
import ModuleMutationInfo from "./components/mutations-info/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";
import css_button from "@/assets/style/src/button.module.less";

//* 插件
const route = useRoute();

//* 数据预取
const data = await api.server("GeneMrnas", "/api/gene/mrnas", { data: { id: route.params.id } });

//* 组合函数
const { vars, refs, nodes, methods, computeds } = useComposable(data);
const { exons } = computeds;
const { modal, select, header, checker, sequence } = nodes;
const { modes, colors } = vars;
const { id, all, exon, mode, range, selects, keyword, selector } = refs;

//* 组件卸载后注销页面滚动事件
onUnmounted(() => window.removeEventListener("scroll", methods.hidden));
//* 组件挂载后获取数据并注册页面滚动事件
onMounted(() => {
    methods.data(refs.keyword.value);
    //* 监听滚动条隐藏下拉框窗口
    window.addEventListener("scroll", methods.hidden);
});
</script>
